import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, Wrench } from "lucide-react";

export default function NotFound() {
  return (
    <section className="relative min-h-screen bg-ink-900 text-paper grain flex items-center overflow-hidden" data-testid="not-found">
      <div className="absolute right-0 top-0 w-[45vw] h-[45vw] rounded-full bg-gold/10 blur-[120px]" />
      <div className="relative z-10 mx-auto max-w-3xl px-5 md:px-10 text-center">
        <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}>
          <Wrench size={40} className="text-gold mx-auto" />
          <div className="font-display text-[26vw] md:text-[16rem] font-bold leading-none tracking-tighter text-gold-grad mt-4">404</div>
          <p className="font-display text-2xl md:text-3xl font-medium mt-2">Cette amélioration n'est pas encore standardisée.</p>
          <p className="text-paper/60 mt-4">La page que vous cherchez est introuvable ou a été déplacée.</p>
          <div className="flex flex-wrap gap-3 justify-center mt-10">
            <Link to="/" className="inline-flex items-center gap-2 rounded-full bg-gold text-ink px-7 py-4 label-mono hover:bg-paper transition-colors">Retour à l'accueil <ArrowUpRight size={15} /></Link>
            <Link to="/outils-apps" className="inline-flex items-center gap-2 rounded-full border border-paper/30 px-7 py-4 label-mono hover:bg-paper hover:text-ink transition-colors">Explorer nos outils</Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
